import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { toast } from "sonner";

export default function Impostazioni() {
  const { logout } = useAuth();
  const nav = useNavigate();
  const [prefs, setPrefs] = useState(null);
  const [confirmDel, setConfirmDel] = useState(false);
  const [deleting, setDeleting] = useState(false);

  useEffect(() => { api.get("/notification-preferences").then(r => setPrefs(r.data)).catch(() => {}); }, []);

  const toggleRetention = async () => {
    try {
      const r = await api.put("/notification-preferences", { product_retention: !prefs?.product_retention });
      setPrefs(r.data);
      toast.success("Preferenze aggiornate");
    } catch (e) { toast.error(formatApiError(e)); }
  };

  const deleteAccount = async () => {
    setDeleting(true);
    try {
      await api.delete("/account");
      await logout();
      nav("/");
    } catch (e) { toast.error(formatApiError(e)); setDeleting(false); }
  };

  return (
    <div className="max-w-3xl mx-auto px-4 py-12" data-testid="impostazioni-page">
      <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight">Impostazioni</h1>

      <section id="notifiche" className="ic-card p-6 mt-8" data-testid="settings-notifications">
        <h2 className="font-bold text-lg mb-4">Notifiche email</h2>
        <div className="space-y-4">
          <label className="flex items-start gap-3">
            <input type="checkbox" checked disabled className="mt-1" data-testid="pref-transactional" />
            <span>
              <span className="font-semibold text-sm block">Email transazionali</span>
              <span className="text-xs text-[#7A7788]">Account, sicurezza e fatturazione. Sempre attive.</span>
            </span>
          </label>
          <label className="flex items-start gap-3 cursor-pointer">
            <input type="checkbox" className="mt-1" data-testid="pref-retention"
              checked={!!prefs?.product_retention} onChange={toggleRetention} disabled={!prefs} />
            <span>
              <span className="font-semibold text-sm block">Aggiornamenti sui tuoi obiettivi</span>
              <span className="text-xs text-[#7A7788]">Ti avvisiamo quando un obiettivo è a rischio o raggiunto.</span>
            </span>
          </label>
        </div>
      </section>

      <section className="ic-card p-6 mt-6 border-[#DC2626]/30" data-testid="settings-danger">
        <h2 className="font-bold text-lg mb-2 text-[#DC2626]">Cancellazione account</h2>
        <p className="text-sm text-[#524F5E]">Elimina definitivamente account, azienda e tutti i dati associati (diritto alla cancellazione GDPR). L'operazione non è reversibile.</p>
        {!confirmDel ? (
          <button className="ic-btn-ghost text-sm mt-4" onClick={() => setConfirmDel(true)} data-testid="delete-account-open">Elimina il mio account</button>
        ) : (
          <div className="mt-4 flex flex-wrap gap-3">
            <button className="ic-btn-primary text-sm" style={{ background: "#DC2626" }} disabled={deleting}
              onClick={deleteAccount} data-testid="delete-account-confirm">{deleting ? "Eliminazione…" : "Confermo, elimina tutto"}</button>
            <button className="ic-btn-ghost text-sm" onClick={() => setConfirmDel(false)} data-testid="delete-account-cancel">Annulla</button>
          </div>
        )}
      </section>
    </div>
  );
}
